import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged, type User } from 'firebase/auth';
import { cacheClear } from './cache';

const firebaseConfig = {
  apiKey: 'AIzaSyDHc082w7xYM9i0jMf0CfK4oCSWcXS3Y4o',
  authDomain: 'auth.nextboost.pro',
  databaseURL: 'https://nextboost-2-0-default-rtdb.firebaseio.com',
  projectId: 'nextboost-2-0',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export async function loginWithGoogle() {
  await signInWithPopup(auth, provider);
}

/** Chaves gravadas por versões anteriores do console. */
const LEGACY_KEYS = ['nbc:me'];

/**
 * Zera todo o estado do operador no navegador.
 *
 * Chamado no logout e sempre que a sessão cai. Também remove chaves de
 * versões antigas: quem já tem o perfil salvo em localStorage precisa que ele
 * seja apagado no primeiro carregamento da versão nova.
 */
export function purgeSession() {
  cacheClear();
  try {
    LEGACY_KEYS.forEach((k) => localStorage.removeItem(k));
    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith('nbc:')) sessionStorage.removeItem(key);
    }
  } catch {
    /* modo privado ou storage bloqueado — o cache em memória já foi limpo */
  }
}

export async function logout() {
  await signOut(auth);
  purgeSession();
}

export function onAuth(cb: (user: User | null) => void) {
  return onAuthStateChanged(auth, cb);
}

export async function getIdToken(force = false) {
  const user = auth.currentUser;
  if (!user) throw new Error('Não autenticado');
  return user.getIdToken(force);
}
